<template>
  <div class="container">
    <div class="top_title"><router-link class="icon_back" :to="{name:'H200050'}" tag="span"></router-link>
      回访详细</div>
    <div class="scroll_area" style="overflow-y: auto">
      <div class="student_info_title" style="margin-top: 2.6rem">
        <span class="icon_student_info"></span>
        <span>学员信息</span>
      </div>
      <div class="student_items">
        <div class="weui-cells item">
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>姓名</p>
            </div>
            <div class="weui-cell__ft">
              <input type="text" class="input_text" disabled :value="info.I_STUDENT_NAME"/>
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>校区</p>
            </div>
            <div class="weui-cell__ft">
              <input type="text" class="input_text" disabled :value="info.I_SCHOOL_NAME"/>
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>班级</p>
            </div>
            <div class="weui-cell__ft">
              <input type="text" class="input_text" disabled :value="info.I_CLASS_NAME"/>
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>老师</p>
            </div>
            <div class="weui-cell__ft">
              <input type="text" class="input_text" disabled :value="info.I_TEACHER" />
            </div>
          </div>
        </div>
      </div>
      <div class="teacher_info_title">
        <span class="icon_parent_info"></span>
        <span>家长信息</span>
      </div>
      <div class="weui-cells item" style="border: 0!important;margin-bottom: 0.66rem">
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>联系电话</p>
          </div>
          <div class="weui-cell__ft">
            <a class="call" :href='"tel://" + info.I_TEL'>
              <input type="text" class="input_text tel" disabled :value="info.I_TEL"/>
              <span></span>
            </a>
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>回访日期</p>
          </div>
          <div class="weui-cell__ft">
            <input type="text" class="input_text" disabled :value="info.I_DATE"/>
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>回访对象</p>
          </div>
          <div class="weui-cell__ft family_member">
            <span :class="{active: info.I_REVISIT_USER_TYPE == '爸爸'}" @click="info.I_REVISIT_USER_TYPE = '爸爸'">爸爸</span>
            <span :class="{active: info.I_REVISIT_USER_TYPE == '妈妈'}" @click="info.I_REVISIT_USER_TYPE = '妈妈'">妈妈</span>
            <span :class="{active: info.I_REVISIT_USER_TYPE == '其他'}" @click="info.I_REVISIT_USER_TYPE = '其他'">其他</span>
          </div>
        </div>
      </div>
      <div class="weui-cells item visitRecords">
        <p class="title"><span></span>回访记录</p>
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>回访方式</p>
          </div>
          <div class="weui-cell__ft radios">
            <label @click="clickRadio($event, '微信')"><span class="icon_yq" :class="{active: info.I_REVISIT_WAY=='微信'}"></span><span>微信</span></label>
            <label @click="clickRadio($event, '电话')"><span class="icon_yq" :class="{active: info.I_REVISIT_WAY=='电话'}"></span><span>电话</span></label>
            <label @click="clickRadio($event, '当面')"><span class="icon_yq" :class="{active: info.I_REVISIT_WAY=='当面'}"></span><span>当面</span></label>
          </div>
        </div>

        <div class="reasons">
          <p class="reasons-title">不续费调查原因</p>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>效果不好</p>
            </div>
            <div class="weui-cell__ft checkbox">
              <span @click="clickCheck($event,'I_VALUE_B1')" :class="{active: info.I_VALUE_B1=='Y'}"></span>
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>接送问题</p>
            </div>
            <div class="weui-cell__ft checkbox">
              <span @click="clickCheck($event,'I_VALUE_B2')" :class="{active: info.I_VALUE_B2=='Y'}"></span>
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>搬家</p>
            </div>
            <div class="weui-cell__ft checkbox">
              <span @click="clickCheck($event,'I_VALUE_B3')" :class="{active: info.I_VALUE_B3=='Y'}"></span>
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>价格不合适</p>
            </div>
            <div class="weui-cell__ft checkbox">
              <span @click="clickCheck($event,'I_VALUE_B4')" :class="{active: info.I_VALUE_B4=='Y'}"></span>
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>课程体系不合适对学校课程没有帮助</p>
            </div>
            <div class="weui-cell__ft checkbox">
              <span @click="clickCheck($event,'I_VALUE_B5')" :class="{active: info.I_VALUE_B5=='Y'}"></span>
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>距离太远</p>
            </div>
            <div class="weui-cell__ft checkbox">
              <span @click="clickCheck($event,'I_VALUE_B6')" :class="{active: info.I_VALUE_B6=='Y'}"></span>
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>坚持不了</p>
            </div>
            <div class="weui-cell__ft checkbox">
              <span @click="clickCheck($event,'I_VALUE_B7')" :class="{active: info.I_VALUE_B7=='Y'}"></span>
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>口语不行</p>
            </div>
            <div class="weui-cell__ft checkbox">
              <span @click="clickCheck($event,'I_VALUE_B8')" :class="{active: info.I_VALUE_B8=='Y'}"></span>
            </div>
          </div>
        </div>

        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>其他</p>
          </div>
          <div class="weui-cell__ft checkbox">
            <span @click="clickCheck($event,'I_VALUE_B9')" :class="{active: info.I_VALUE_B9=='Y'}"></span>
          </div>
        </div>
        <!--<textarea class="parent_communication" placeholder="请输入其他内容" v-model="info.I_REMARK"></textarea>-->
        <el-input
          style="border: 0;outline: none;"
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 10}"
          placeholder="请输入沟通内容"
          v-model="info.I_REMARK">
        </el-input>
      </div>

      <button class="bottom_btn" @click="save">保存</button>
      <!-- <p class="mark">新保存的回访记录30分钟内可修改</p> -->
    </div>
  </div>
</template>

<script>
  import DataRequestFactory from '@/factories/dataRequestFactory.js'
  import weui from 'weui.js'
  export default {
    name: '',
    data () {
      return {
        info: {}
      }
    },
    created() {
      let info = this.$route.params.info

      if(info) {
        window.localStorage.setItem("H200060",info)
        info = JSON.parse(info)
      } else {
        info = JSON.parse(window.localStorage.getItem("H200060"))
      }
      DataRequestFactory.I200060(info).then((response) => {
        this.info = response
      })
    },
    methods: {
      clickRadio(e, value) {
        $(e.currentTarget).parent().find('.icon_yq.active').removeClass("active")
        $(e.currentTarget).find('.icon_yq').addClass("active")
        this.info.I_REVISIT_WAY = value
      },
      clickCheck(e, value) {
        if($(e.currentTarget).hasClass("active")) {
          $(e.currentTarget).removeClass("active")
          this.info[value] = 'N'
        } else {
          $(e.currentTarget).addClass("active")
          this.info[value] = 'Y'
        }
      },
      save () {
        let params = {
          "I_SCHOOL_NO": this.info.I_SCHOOL_NO,
          "I_CLASS_NO": this.info.I_CLASS_NO,
          "I_STUDENT_NO": this.info.I_STUDENT_NO,
          "I_DATE": this.info.I_DATE,
          "I_TEL": this.info.I_TEL,
          "I_REVISIT_USER_TYPE": this.info.I_REVISIT_USER_TYPE,
          "I_REVISIT_WAY": this.info.I_REVISIT_WAY,
          "I_VALUE_B1": this.info.I_VALUE_B1 || 'N',
          "I_VALUE_B2": this.info.I_VALUE_B2 || 'N',
          "I_VALUE_B3": this.info.I_VALUE_B3 || 'N',
          "I_VALUE_B4": this.info.I_VALUE_B4 || 'N',
          "I_VALUE_B5": this.info.I_VALUE_B5 || 'N',
          "I_VALUE_B6": this.info.I_VALUE_B6 || 'N',
          "I_VALUE_B7": this.info.I_VALUE_B7 || 'N',
          "I_VALUE_B8": this.info.I_VALUE_B8 || 'N',
          "I_VALUE_B9": this.info.I_VALUE_B9 || 'N',
          "I_REMARK": this.info.I_REMARK,
        }
        DataRequestFactory.I200061(params).then((response) => {
          if(response.resultCode == 0) {
//          this.$router.replace({ name: 'H080020'})
            weui.topTips("保存成功");
            let H200060Info = {
              I_SCHOOL_NO: this.info.I_SCHOOL_NO,
              I_CLASS_NO: this.info.I_CLASS_NO,
              I_STUDENT_NO: this.info.I_STUDENT_NO
            }
            this.$router.push({name:'H200050', params: {info: JSON.stringify(H200060Info)}})
          }
        })
      }
    },
    mounted() {
      var win_h = $(window).height();  //关键代码
      $("body").height(win_h);  //关键代码
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import '../assets/css/pages/H200060.css';
  @import '../assets/css/common.css';
</style>

<style>
  .el-textarea__inner {
    border: 0;
    outline: none;
    padding: 0.8rem;
    width: 100%;
    height: 8rem;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/pages/H200060.vue